import { useQuery } from '@tanstack/react-query';
import { dashboardApi } from '../services/api';
import { useTenant } from '../contexts/TenantContext';

/**
 * Fetches the unified score summary with data freshness indicators.
 * Used by KpiRow to show "Pending" / "Stale" badges on KPI cards.
 */
export function useScoreSummary() {
  const { isResolved } = useTenant();

  return useQuery({
    queryKey: ['scoreSummary'],
    queryFn: () => dashboardApi.getScoreSummary(),
    enabled: isResolved,
    staleTime: 60_000,
    refetchInterval: 300_000,
  });
}
